

// import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface SidebarState {
//   activeTabs: string[]; 
// }

// const initialState: SidebarState = {
//   activeTabs: ["/tourManagement/create/packageName"], 
// };

// const sidebarSlice = createSlice({
//   name: "sidebar",
//   initialState,
//   reducers: {
//     setActiveTab: (state, action: PayloadAction<string>) => {
//       if (!state.activeTabs.includes(action.payload)) {
//         state.activeTabs.push(action.payload);
//       }
//     },
//   },
// });

// export const { setActiveTab } = sidebarSlice.actions;

// export default sidebarSlice.reducer;


import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  activeTabs: string[]; // Array of active tab paths
}

// Initialize state from localStorage or use the default initial state
const initialState: SidebarState = {
  activeTabs: JSON.parse(localStorage.getItem("activeTabs") || "[]") || [
    "/tourManagement/create/packageName",
  ],
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    // Add a tab to activeTabs if it isn't already included
    addActiveTab: (state, action: PayloadAction<string>) => {
      if (!state.activeTabs.includes(action.payload)) {
        state.activeTabs.push(action.payload);
        localStorage.setItem("activeTabs", JSON.stringify(state.activeTabs));
      }
    },
    // Remove a tab from activeTabs
    removeActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTabs = state.activeTabs.filter(
        (tab) => tab !== action.payload
      );
      localStorage.setItem("activeTabs", JSON.stringify(state.activeTabs));
    },
    // Reset all active tabs (useful for clearing session)
    resetActiveTabs: (state) => {
      state.activeTabs = [];
      localStorage.removeItem("tourState")
      localStorage.removeItem("activeTabs");

      console.log("tourState removed from localStorage:", !localStorage.getItem("tourState"));
     console.log("activeTabs removed from localStorage:", !localStorage.getItem("activeTabs"));
    },
    // Optionally rehydrate state from localStorage
    rehydrateActiveTabs: (state) => {
      state.activeTabs = JSON.parse(localStorage.getItem("activeTabs") || "[]");
    },
  },
});

export const { addActiveTab, removeActiveTab, resetActiveTabs, rehydrateActiveTabs } =
  sidebarSlice.actions;

export default sidebarSlice.reducer;

